import Numpad from "./keyboard/Numpad";

export {
  Numpad,
};

export default {};
